export const blueprintResourceNotFoundErrorMessage = {
  sectionGroup: 'section group blueprint not found',
  section: 'section blueprint not found',
  subsection: 'subsection blueprint not found for',
  question: 'question blueprint not found for',
  field: 'field blueprint not found for',
  selectOption: 'select option blueprint not found for',
};
